export const ICON_PRICE = { energy: 5, money: 5000 };
export const REFERRAL_BONUS = { money: 1000, energy: 0 };
